import React, { Component } from 'react';
import '../../App.css';

class Time extends Component {

constructor() {
	super();
	this.state = {timer: 10};
}

componentDidMount() {
	this.timer();
}

timer() {

	let timer = this.state.timer;

	let Timing = setInterval(()=>{this.setState(state => ({timer: state.timer -= 1}))}, 1000);

	setTimeout(()=>{clearInterval(Timing);this.props.nextStage();return}, 10000);
}

  render() {
    return (
      <div id="nothing"></div>
    );
  }
}

export default Time;



// WEBPACK FOOTER //
// ./src/components/layouts/Time.js